import React, { useState } from 'react'
import { useForm, Controller } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { Navigate, useNavigate } from 'react-router-dom'

import { login, getToken, withPosthog } from '../../core'
import { LabeledInput, LogoIcon, Button, LoaderIcon } from '../../components'
import { PageWrapper, FormWrapper, StyledForm, ButtonsWrapper, LinkText } from './styled'

const Login = () => {
  const [loading, setLoading] = useState(false)
  const { t } = useTranslation()
  const navigate = useNavigate()
  const { control, handleSubmit, setError, formState: { errors } } = useForm()

  const onSubmit = async (data) => {
    setLoading(true)
    try {
      await login(data)

      withPosthog((posthog) => {
        posthog.identify(data.username, { email: data.email, name: data.username })
        posthog.capture('login success', { method: 'password', origin: 'web' })
      })

      navigate('/fleet/map')
    } catch (err) {
      const payload = err.response?.data
      if (payload && typeof payload === 'object') {
        Object.entries(payload).forEach(([field, msgs]) => {
          const message = Array.isArray(msgs) ? msgs.join(', ') : String(msgs)
          if (field === 'username' || field === 'email' || field === 'password') {
            setError(field === 'email' ? 'username' : field, { type: 'server', message })
          } else {
            setError('detail', { type: 'server', message })
          }
        })
      } else {
        setError('detail', { type: 'server', message: err.message || t('errors.unknown') })
      }
    } finally {
      setLoading(false)
    }
  }

  if (getToken()) {
    return <Navigate to="/fleet/map" replace />
  }

  return (
    <PageWrapper>
      <FormWrapper>
        <StyledForm onSubmit={handleSubmit(onSubmit)}>
          <LogoIcon style={{ marginBottom: 16 }} />

          <Controller
            defaultValue=""
            name="username"
            control={control}
            render={({ field }) =>
              <LabeledInput
                label={t('loginForm.placeholders.login')}
                {...field}
                ref={null}
                error={!!errors.username}
                errorMessage={errors.username?.message}
              />
            }
          />

          <Controller
            defaultValue=""
            name="password"
            control={control}
            render={({ field }) =>
              <LabeledInput
                type="password"
                label={t('loginForm.placeholders.password')}
                {...field}
                ref={null}
                error={!!errors.password}
                errorMessage={errors.password?.message}
              />
            }
          />

          {errors.detail && (
            <div style={{ color: '#ff4d4f', fontSize: 12, marginTop: 8 }}>
              {t('errorMessages.auth')}
            </div>
          )}

          <ButtonsWrapper>
            <Button btnstyle="login" variant="contained" type="submit" disabled={loading}>
              {loading ? <LoaderIcon /> : t('loginForm.buttons.login')}
            </Button>

            <LinkText type="button">
              {t('loginForm.links.forgotPassword')}
            </LinkText>

            <Button btnstyle="alt" variant="contained" onClick={() => navigate('/register')}>
              {t('loginForm.buttons.register')}
            </Button>
          </ButtonsWrapper>
        </StyledForm>
      </FormWrapper>
    </PageWrapper>
  )
}

export default Login
